import { render, staticRenderFns } from "./index.vue?vue&type=template&id=60c2cbd0&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=60c2cbd0&prod&scoped=true&lang=css"
import style1 from "./index.vue?vue&type=style&index=1&id=60c2cbd0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c2cbd0",
  null
  
)

export default component.exports